/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily>): BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily(), model);
        BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily>): BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily.newInstance(<BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
